var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import GroupedItem from 'components/dropdown/Menu/GroupedList/Item';
import React, { forwardRef } from 'react';
import cl from 'clsx';
export const GroupedHeading = forwardRef((_a, ref) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return (React.createElement("dt", Object.assign({}, rest, { ref: ref, className: cl('cds-dropdown__list-heading', 'cds-heading', 'cds-heading--xsmall', className) })));
});
GroupedItem.displayName = 'Dropdown.Menu.DescriptionList.GroupedHeading';
export default GroupedHeading;
